Vue.component('app-new-subscription', {
  props: {
    plans: [],
  },

  data: function() {
    return {
      planId: '',
      selectedPlan: '',
    };
  },

  ready: function() {},

  methods: {
    planChange: function() {
      this.selectedPlan = this.getPlanById(this.planId);
      console.log(this.selectedPlan.features);
    },
    getPlanById: function(planId) {
      return _.find(this.plans, { id: planId });
    },
  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/new_subscription_order.js